import "./Terms.css";

const CarlshoppyTerms = () => {
  return (
    <div className="tandc-page">
      <div className="tandc">
        {/*  Page Heading */}
        <h3 className="page-title" align="center">
          “HOPPY Hour Off Trade” [CAMPAIGN]
        </h3>
        {/* Heading */}
        {/* <p align="center" style={{ lineHeight: "16px" }}>
          Fantastik Chocostick Promotion - (ROI)
        </p> */}

        <div className="term-container">
          <div className="sub-term-container">
            <p style={{ textDecoration: "underline" }}>Terms and Conditions</p>

            <div>
              The campaign is being organized and executed <strong> by PINE LABS LIMITED
                (“Pine Labs”)</strong> on behalf of <strong> Carlsberg India Limited</strong> (hereinafter
              referred to as Organizer). Pine Labs is the agency providing
              technical support to <strong> Carlsberg India Limited/Company </strong> for
              organizing the Campaign “Hoppy Hour” (hereinafter referred to as
              <strong>“Agency”)</strong> and will be responsible for managing the website. By
              participating/ availing this Campaign, it is deemed that the participants/ customers/ consumers
              (hereinafter collectively referred to as “Participant / Participants/User”) and/or Winners have
              irrevocably and unconditionally accepted all terms &amp; conditions contained herein, including any/all
              amendments, modifications, etc. made thereto without demur and shall throughout remain bound to
              them as under:
            </div>
            <div>
              <ol>
                <li><strong>Agreement to Terms and Conditions –</strong></li>
                <div style={{ marginLeft: "1.3rem" }}>
                  <ol>
                    <li>
                      <p>
                        By participating in this Campaign, Participants fully and unconditionally agree to abide by
                        the Terms and Conditions available on the unique URL carlshoppy.in Organizer’s
                        decision shall be ﬁnal and binding in all matters related to the Campaign and is subject to
                        all requirements set forth herein.
                      </p>
                    </li>

                    <li>
                      <p>
                        Organizer reserves the right to exclude any person/s from the Campaign on grounds of
                        misconduct or criminal record.
                      </p>
                    </li>
                    <li>
                      <p>
                        Organizer reserves the right to terminate, modify or extend the Campaign, at any time at
                        its absolute discretion, without assigning any reason or prior intimation to the Participant.
                      </p>
                    </li>
                    <li>
                      <p>
                        This Campaign is open only for Indian citizens above the Legal Drinking Age as
                        applicable in each state.
                      </p>
                    </li>
                  </ol>
                </div>
                <li><strong>Eligibility & Campaign Period –</strong></li>
                <div style={{ marginLeft: "1.3rem" }}>
                  <ol>
                    <li>
                      <p>
                        Organizers’ employees, their family members, sponsors, agents, distributors,
                        wholesalers, retailers, and any other channel partners, including their employees or any
                        outlet staﬀ, bar staﬀ and counter salesmen are not eligible to participate in the Campaign.
                        Entries received from any of the foregoing ineligible participants shall be liable to be
                        rejected by the Organizers at any stage of the Campaign without demur.
                      </p>
                    </li>

                    <li>
                      <p>
                        Only those winners who are above Legal Drinking Age and residents of the State shall be
                        entitled to the Prize(s) upon submission of valid address proof to the satisfaction of the
                        Organizers. In case any participant/winner is found to be a resident of a State other than
                        a participating State (“State of Participation”) at the time of delivery of prize his/her entry
                        shall not be considered valid, and the organizer shall be free to choose an alternate
                        winner from the said State of Participation. The State of Participation shall be determined
                        by presentation of any valid address proof (e.g., Driving License, Aadhar Card or
                        Electricity Bill in the name of the Winner)).
                      </p>
                    </li>
                    <li>
                      <p>
                        The Campaign is open between the Start date & End date  <strong>((1st Sep 2026 till 31st Dec
                          2027))</strong> both days inclusive and till stock lasts whichever is earlier, as indicated in the Table
                        above (“Campaign Period”).
                      </p>
                    </li>
                    <li>
                      <p>
                        The Organizers reserve the right to change the Campaign Period without prior intimation
                        to the Participant. Thereafter, Organizers will not be obligated in any manner and for any
                        reason of whatsoever nature. Entries received beyond the Campaign Period will not be
                        considered valid for participation in the Campaign for any reasons whatsoever and no
                        request for extension shall be entertained and no communication by any means in this
                        regard shall be accepted.
                      </p>
                    </li>
                  </ol>
                </div>
                <li>
                  <p><strong>How to Participate</strong></p>
                  <div style={{ marginLeft: "1.3rem" }}>
                    <ol>
                      <li>
                        <p>
                          This Campaign is applicable on Pack Size and Brand communicated at the Outlet.
                        </p>
                      </li>

                      <li>
                        <p>
                          To participate in the Campaign, Consumer will purchase the Pack and quantity as
                          communicated at the Outlet level communication /
                        </p>
                      </li>

                      <li>
                        <p>
                          Consumer will finds QR code and a unique code on the
                          Booklet Scratch card
                        </p>
                      </li>

                      <li>
                        <p>
                          Consumer to scan the QR code and lands on WhatsApp
                          Chatbot
                        </p>
                      </li>

                      <li>
                        <p>
                          Consumer must select a State from where they are participating out of the mentioned
                          states- Maharashtra, Karnataka ,West Bengal , Goa , UP , Haryana , Orrisa , Rajasthan.
                        </p>
                      </li>

                      <li>
                        <p>
                          Consumer must then agree to the LDA and Terms & Conditions to proceed and
                          participate
                        </p>
                      </li>

                      <li>
                        <p>
                          Consumer should register themselves by entering their Name and unique code
                        </p>
                      </li>

                      <li>
                        <p>
                          Upon successful Registration and Unique Code Validation, the cashback and Gift
                          Voucher options will open up for the consumer to redeem.
                        </p>
                      </li>

                      <li>
                        <p>Cashback can be redeemed via UPI ID</p>
                      </li>

                      <li>
                        <p>
                          1 mobile number can participate once per day, twice per week & thrice per month.
                        </p>
                      </li>

                      <li>
                        <p>
                          1 mobile number can participate a maximum of 3 times per month.
                        </p>
                      </li>

                      <li>
                        <p>
                          Participation will not be allowed between 12am to 9am.
                        </p>
                      </li>

                      <li>
                        <p>
                          Only Participants registering with the correct details will be considered eligible for the
                          Campaign. In case a Participant’s age is less than the Legal Drinking Age as prescribed
                          by State the participation will not be considered.
                        </p>
                      </li>

                      <li>
                        <p>
                          Participants entering a code which is mapped to a different state than the state where the
                          booklet is issued, will not be allowed to participate.
                        </p>
                      </li>

                      <li>
                        <p>
                          The Organizers shall not be responsible for (including but not limited to):
                        </p>
                        <div style={{ marginLeft: "0.5rem" }}>
                          <p>• Any SPAM generated messages.</p>
                          <p>
                            • The Operator Code is not displayed on the user’s
                            mobile phone. Any SMS message delivery failure.
                          </p>
                          <p>
                            • Any lost, late or misdirected computer transmission
                            or network, electronic failures or any kind of any
                            failure to receive entries owing to transmission
                            failures or due to any technical reason.
                          </p>
                          <p>
                            • If the participant has registered himself / herself to the DND of the telecom provider/
                            the participant has registered with National Do Not Call Registry/ Participant has
                            speciﬁcally requested for not receiving messages for the speciﬁc campaign
                          </p>
                          <p>• Other conditions beyond its reasonable control.</p>
                        </div>
                      </li>
                      <li>
                        The decision on number/s of winners is subject to change
                        at the Organizer’s discretion.
                      </li>
                    </ol>
                  </div>
                </li>
                <li>
                  <strong>Personal Data Protection and Privacy Policy -</strong>
                  <div style={{ marginLeft: "1.3rem" }}>
                    <ol>
                      <li>
                        <p>
                          At the time of participating in this Campaign, the Participant hereby unconditionally
                          consents and authorizes the Organizers to collect certain information about the
                          Participant (hereinafter ‘Personal Data’).
                        </p>
                      </li>
                      <li>
                        <p>
                          Personal Data will be stored as long as such data is
                          necessary for the purpose of this Campaign. Further,
                          said Personal Data shall not be transferred or handed
                          to any third parties other than any government
                          authority where required to do so under applicable
                          law.
                        </p>
                      </li>
                      <li>
                        <p>
                          I hereby irrevocably and absolutely appoint Pine Labs Limited as my Facilitator for the
                          purpose of facilitating the transfer to my bank account for the HOPPY Hour Off Trade
                          Promotion Program and expressly share my personal information for this purpose. I
                          further consent to and authorize Pine Labs Limited to process and store my personal
                          information (including any sensitive personal data)"
                        </p>
                      </li>
                    </ol>
                  </div>
                </li>
                <li>
                  <strong>Company and Agency shall not be responsible for (including but
                    not limited to):</strong>
                  <div style={{ marginLeft: "1.3rem" }}>
                    <ol>
                      <li>
                        <p>For any SPAM generated messages;</p>
                      </li>

                      <li>
                        <p>For any SMS message delivery failures;</p>
                      </li>

                      <li>
                        <p>
                          Any lost, late or misdirected computer transmission or network, electronic failures or any
                          kind of any failure to receive entries owing to transmission failures or due to any technical
                          reason;
                        </p>
                      </li>

                      <li>
                        <p>
                          If the User has registered himself to the DND of the telecom provider/ the User has
                          registered with National Do Not Call Registry/ User has specifically requested for not
                          receiving messages for the specific campaign;
                        </p>
                      </li>

                      <li>
                        <p>Other conditions beyond its reasonable control.</p>
                      </li>

                      <li>
                        <p>
                          Company or Agency will not be responsible for any NDNC (National Do Not Call) Registry
                          regulation that will come into play. All User who wishes to participate will agree as per the
                          terms and conditions that even if they are registered under NDNC, DND (Do Not Disturb)
                        </p>
                      </li>
                    </ol>
                  </div>
                </li>
                <li>
                  <strong>Publicity:</strong>
                  <div style={{ marginLeft: "1.3rem" }}>
                    <ol>
                      <li>
                        <p>
                          The Company has the right to cover the Campaign through various media including
                          newspapers, radio television news channels, internet, point of sale materials, etc., and
                          the User shall not raise any objection, protest or demur to such coverage or in this regard.
                        </p>
                        <li>
                          <p>
                            The winners must, at the request of Company, participate in all promotional activity (such
                            as publicity and photography) surrounding the winning of the prize, free of charge, and
                            they consent to Company using their name and image in promotional material.
                          </p>
                        </li>
                      </li>
                    </ol>
                  </div>
                </li>
                <li>
                  <strong>Intellectual Property:</strong>
                  <div style={{ marginLeft: "1.3rem" }}>
                    <ol>
                      <li>
                        <p>
                          All right, title and interest, including but not limited to the Intellectual Property Rights, in
                          the promotional material(s) and in any and all responses received shall vest solely and
                          exclusively with Company at all times. Company or any person or entity permitted by

                          Company in this regard shall be entitled to use the responses received or any information
                          in connection with the entry in any media for future promotional, marketing, publicity, and
                          any other purpose, without any permission and or payment to the User.
                        </p>
                      </li>
                      <li>
                        <p>
                          The Company has all the exclusive rights, title and interest in all the materials submitted
                          in connection with the Program (whether written, audio, electronic or visual form, or a
                          combination of those) including any photographs, video and/or film footage and/or audio
                          recording taken of User. Company may use the material in any medium in any
                          reasonable manner it sees fit. Copyright in any such material remains the sole property of
                          Company.
                        </p>
                      </li>
                    </ol>
                  </div>
                </li>
                <li>
                  <strong>General Conditions:</strong>
                  <div style={{ marginLeft: "1.3rem" }}>
                    <ol>
                      <li>
                        <p>
                          The Participant understands and agrees that the selected Winner(s) alone shall be entitled to
                          the Prize, subject to all terms and conditions mentioned herein, and furnishing of correct and
                          complete details during the KYC veriﬁcation in the prescribed manner and to the entire
                          satisfaction of the Organizer/s.
                        </p>
                      </li>

                      <li>
                        <p>
                          The Campaign will be Campaigned at the sole discretion of the Organizer/s.
                        </p>
                      </li>

                      <li>
                        <p>
                          The prize/s declared under this Campaign shall non-transferable, non-redeemable and cannot
                          be converted to any cash.
                        </p>
                      </li>

                      <li>
                        <p>
                          The Prize is subject to the applicable laws of India. Any deduction of applicable taxes, levies
                          and other statutory payments, including but not limited to applicable gift tax, shall be borne
                          solely by the Winner. The prize would be delivered / handed over to the Winner only upon
                          proper identiﬁcation and veriﬁcation of the Participant to the full satisfaction of the Organizer.
                          In case the prize remains undelivered for reasons for change of address, wrong address
                          provided by the winner, winner not available at the provided address, which is beyond the
                          control of Organizer, the Organizer shall not be obliged to reach out to the participant and
                          Organizer will not be held responsible on this account under any circumstances.
                        </p>
                      </li>

                      <li>
                        <p>
                          Organizer/s shall provide the Prize on &quot;as-it-is” basis without any warranty or guarantee
                          (whether express or implied) regarding the prize covering its quality, suitability, merchantability
                          or its ﬁtness. The Organizer/s, its management, directors, employees, oﬃcers, aﬃliates or
                          subsidiaries, agents, representatives, etc. disclaims itself from any and all liabilities, including
                          but not limited to, those arising due to any deﬁciency/ defect in the Campaign and/or Prize and
                          for any consequential damages/ losses arising with respect to the Campaign and/or the Prize.
                        </p>
                      </li>

                      <li>
                        <p>
                          Organizer/s reserves its right to select and declare or not to declare the prize Winner if the
                          number of entries submitted for the Campaign is not up to the logistical satisfaction of
                          Organizer. Decision of Organizer/s in this regard shall be ﬁnal &amp; binding, and no
                          correspondence in this regard shall be entertained.
                        </p>
                      </li>

                      <li>
                        <p>
                          Organizer reserves its right to change, defer, alter or cancel this Campaign in part or full, or
                          change any or all terms and conditions of the Campaign, without giving any prior intimation/
                          notice of any kind. Further, it shall not be liable for any consequential losses / damages to any
                          Participant and/or Winners in this regard. Decision of the Organizer in general and with
                          respect to this Campaign in particular, shall be full, ﬁnal, binding and non-contestable upon the
                          Participant and/or the Winners.
                        </p>
                      </li>

                      <li>
                        <p>
                          Nothing contained herein amounts to a commitment or representation by the Organizer to
                          conduct further likewise Campaign or schemes.
                        </p>
                      </li>

                      <li>
                        <p>
                          The Campaign and the terms and conditions herein shall be governed by and construed in
                          accordance with the applicable laws in India. All matters with respect to the Campaign and/or
                          prizes are subject to the exclusive jurisdiction of the Courts at Mumbai only. The Campaign
                          shall be deemed void where prohibited by law.
                        </p>
                      </li>

                      <li>
                        <p>
                          Under no circumstance the Organizer, its management, directors, employees, oﬃcers,
                          aﬃliates or subsidiaries, agents, representatives, etc. shall be liable to the Participant,
                          Winners and/or any third party for any loss of proﬁts or lost opportunity, or for any indirect,
                          special, consequential, incidental, or punitive damages whatsoever, even if Organizer has
                          been advised of the possibility of any such damages. The Participant/ Winners speciﬁcally
                          agree not to ﬁle and/or initiate in person or through any family member or through any third
                          party, any criminal and/or civil proceedings/ complaints/ applications in any courts or forum in
                          India against Organizer, its management, directors, employees, oﬃcers, aﬃliates or
                          subsidiaries, agents, representatives, etc. to claim any damages for any losses or seek relief
                          in connection with the Campaign and/or the prizes. The Participant/ Winners speciﬁcally agree
                          that Organizer, its aﬃliates, its group companies, their employees, oﬃcers, directors or any
                          other person and/or sponsors shall not be responsible for any claims/ liabilities/ losses
                          (including legal fees) arising out of and in relation to any injury/ damage/ harm/ loss/ death/

                          mental or emotional trauma suﬀered by the Participant or prize Winners in any manner
                          whatsoever in connection with the Campaign and/or the prizes.
                        </p>
                      </li>

                      <li>
                        <p>
                          Support Email for Campaign –{" "}
                          <a href="mailto:carlshoppy@pinelabs.com">
                            carlshoppy@pinelabs.com
                          </a>
                        </p>
                      </li>
                    </ol>
                  </div>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarlshoppyTerms;
